// Propiedades.jsx
import React, { useState, useEffect, useRef } from 'react';
import styles from './styles.module.scss';
import { Components } from './ComponentsTypes';
import Select from 'react-select';
import { compressFileToBase64 } from '../../globalFunctions';

function isNumberArray(v: any): v is number[] {
    return Array.isArray(v) && v.every(item => typeof item === 'number');
}

export default function Propiedades({ selected, onTextChange, deleteSelected, options }) {
    const multiple = isNumberArray(selected);
    useEffect(() => {
        if (!multiple) {
            setText(selected?.text || '');
            setImagem(
                selected?.imagem ||
                    ''
            );
            setCss(selected?.css || defaultCss);
            setCorrect(selected?.correct);
            setMultiplo(selected?.multiplo);
            const normalized: Option[] = Array.isArray(selected?.dropAreas)
                ? selected.dropAreas.map((val: string) => ({ label: val, value: val }))
                : [];
            setDropAreas(normalized);
        }
    }, [selected]);

    const defaultCss = {
        borderStyle: 'none',
        color: '#000',
        borderColor: 'black',
        transform: 'scale(1)'
    };
    const [dropAreas, setDropAreas] = useState<Option[]>(selected?.dropAreas || []);
    const [css, setCss] = useState(selected?.css || defaultCss);
    const prevCss = useRef(css);
    const [text, setText] = useState(selected?.text || '');
    const [url, setUrl] = useState(selected?.url || '');
    const [imagem, setImagem] = useState(
        selected?.imagem || ''
    );
    const [correct, setCorrect] = useState(selected?.correct || false);
    const [multiplo, setMultiplo] = useState(selected?.multiplo || false);
    
    const handleChange = mudou => {
        // Chama a callback passando o novo valor do texto
        if (onTextChange) {
            onTextChange(mudou);
        }
    };

    useEffect(() => {
        if (onTextChange && !multiple) {
            handleChange({ text: text });
        }
    }, [text]);

    // Chama onTextChange com a variável 'correct'
    useEffect(() => {
        if (onTextChange) {
            handleChange({ correct: correct });
        }
    }, [correct]);

    // Chama onTextChange com a variável 'imagem'
    useEffect(() => {
        if (onTextChange) {
                handleChange({ imagem: imagem });
        }
    }, [imagem]);

    // Chama onTextChange com a variável 'url'
    useEffect(() => {
        if (onTextChange) {
            handleChange({ url: url });
        }
    }, [url]);

    // Chama onTextChange com a variável 'multiplo'
    useEffect(() => {
        if (onTextChange) {
            handleChange({ multiplo: multiplo });
        }
    }, [multiplo]);

    // Chama onTextChange com a variável 'css'
    useEffect(() => {
        // Apenas se onTextChange estiver disponível
        if (onTextChange) {
            // Objeto para armazenar as propriedades que mudaram
            const changes = {};

            // Itera sobre as chaves do objeto CSS atual
            for (const key in css) {
                // Compara o valor da propriedade atual com o valor anterior
                if (css[key] !== prevCss.current[key]) {
                    changes[key] = css[key];
                }
            }

            // Se alguma propriedade mudou, chama onTextChange com a mudança
            if (Object.keys(changes).length > 0) {
                handleChange({ css: changes });
            }
        }

        // Atualiza a referência para a próxima renderização
        prevCss.current = css;
    }, [css]);

    // Chama onTextChange com a variável 'dropAreas'
    useEffect(() => {
        if (onTextChange) {
            onTextChange({ dropAreas: dropAreas.map(e => e?.value) });
        }
    }, [dropAreas]);
    if (!selected) return <></>;

    type Option = { value: string; label: string };
    const fontOptions = [
        { label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
        { label: 'Helvetica Neue', value: "'Helvetica Neue', Helvetica, Arial, sans-serif" },
        { label: 'Times New Roman', value: "'Times New Roman', Times, serif" },
        { label: 'Georgia', value: 'Georgia, serif' },
        { label: 'Courier New', value: "'Courier New', Courier, monospace" },
        { label: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
        { label: 'Tahoma', value: 'Tahoma, Geneva, sans-serif' },
        { label: 'Trebuchet MS', value: "'Trebuchet MS', sans-serif" },
        { label: 'Lucida Console', value: "'Lucida Console', Monaco, monospace" },
        { label: 'Monaco', value: 'Monaco, Menlo, monospace' },
        { label: 'Comic Sans MS', value: "'Comic Sans MS', cursive, sans-serif" },
        { label: 'Impact', value: 'Impact, Charcoal, sans-serif' },
        { label: 'Segoe UI', value: "'Segoe UI', Tahoma, Geneva, sans-serif" },
        { label: 'system-ui', value: 'system-ui' },
        { label: 'serif', value: 'serif' },
        { label: 'sans-serif', value: 'sans-serif' },
        { label: 'monospace', value: 'monospace' },
        { label: 'cursive', value: 'cursive' },
        { label: 'fantasy', value: 'fantasy' }
    ];

    const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        // Se for GIF, lê diretamente como Base64 (mantém animação)
        if (file.type === 'image/gif') {
            const reader = new FileReader();
            reader.onload = () => {
                if (typeof reader.result === 'string') {
                    setImagem(reader.result);
                }
            };
            reader.readAsDataURL(file);
            return;
        }

        // Senão, comprime + redimensiona
        try {
            const base64 = await compressFileToBase64(file, 200 /* max KB */, 1024 /* max width */);
            setImagem(base64);
        } catch (err) {
            console.error('Erro ao comprimir imagem:', err);
        }
    };

    const ImageToString = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        return await compressFileToBase64(file,200,1024)
    };

    const renderProps = type => {
        var content: any = [];
        const props: string[] = Components[type];

        if (props) {
            props.forEach(prop => {
                switch (prop) {
                    case 'texto':
                        content.push(
                            <>
                                <hr />
                                <p>Texto: </p>
                                <input
                                    type='text'
                                    value={text}
                                    onChange={e => {
                                        setText(e.target.value);
                                    }}
                                    className={styles.input}
                                />
                                <p>Tamanho texto: {css.fontSize} </p>
                                <p></p>
                                <input
                                    className={styles.range}
                                    type='range'
                                    min={0.5}
                                    max={500}
                                    step={0.1}
                                    value={parseFloat(css.fontSize)}
                                    onChange={e => {
                                        setCss({ ...css, fontSize: e.target.value + '%' });
                                    }}
                                />
                                <p>Cor do Texto: {css.color} </p>
                                <input
                                    className={styles.inputColor}
                                    type='color'
                                    value={css.color}
                                    onChange={e => setCss({ ...css, color: e.target.value })}
                                />

                                <div className={styles.selectWrapper} key='fontFamily'>
                                    <p>Fonte: </p>
                                    <select
                                        style={{ fontFamily: css.fontFamily }}
                                        value={css.fontFamily}
                                        className={styles.selectCustom}
                                        onChange={e =>
                                            setCss({ ...css, fontFamily: e.target.value })
                                        }
                                    >
                                        {fontOptions.map(({ label, value }) => (
                                            <option
                                                style={{ fontFamily: value }}
                                                key={value}
                                                value={value}
                                            >
                                                {label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </>
                        );
                        break;
                    case 'border':
                        content.push(
                            <>
                                <hr />

                                <div className={styles.selectWrapper}>
                                    <p>Tipo de borda: </p>
                                    <select
                                        className={styles.selectCustom}
                                        name='borderStyle'
                                        id='style'
                                        onChange={e => {
                                            setCss({ ...css, borderStyle: e.target.value });
                                        }}
                                        value={css.borderStyle}
                                    >
                                        <option value='none'>nenhuma</option>
                                        <option value='solid'>sólida</option>
                                        <option value='dotted'>pontilhada</option>
                                        <option value='dashed'>traçada</option>
                                    </select>
                                </div>

                                <p>Largura da borda: {css.borderWidth} </p>
                                <input
                                    className={styles.range}
                                    type='range'
                                    min={0}
                                    max={15}
                                    step={0.1}
                                    value={parseFloat(css.borderWidth)}
                                    onChange={e => {
                                        setCss({ ...css, borderWidth: e.target.value + 'px' });
                                    }}
                                />
                                <p>Arredondamento da borda: {css.borderRadius} </p>
                                <input
                                    className={styles.range}
                                    type='range'
                                    min={0}
                                    max={999}
                                    step={0.1}
                                    value={parseFloat(css.borderRadius)}
                                    onChange={e => {
                                        setCss({ ...css, borderRadius: e.target.value + 'px' });
                                    }}
                                />
                                <p>Cor da borda: {css.borderColor} </p>
                                <input
                                    className={styles.inputColor}
                                    type='color'
                                    value={css.borderColor}
                                    onChange={e => setCss({ ...css, borderColor: e.target.value })}
                                />
                            </>
                        );
                        break;

                    case 'background':
                        content.push(
                            <>
                                <hr />
                                <p>Cor de fundo: {css.backgroundColor} </p>
                                <input
                                    className={styles.inputColor}
                                    type='color'
                                    value={css.backgroundColor}
                                    onChange={e =>
                                        setCss({
                                            ...css,
                                            backgroundColor: hexToRgbaString(
                                                e.target.value,
                                                getAlphaFromRgbaString(css.backgroundColor) || 1
                                            )
                                        })
                                    }
                                />
                                <p>
                                    Transparência:{' '}
                                    {100 -
                                        Math.round(
                                            (getAlphaFromRgbaString(css.backgroundColor) ?? 1) * 100
                                        )}
                                    %
                                </p>
                                <input
                                    type='range'
                                    className={styles.range + ' invertido'}
                                    min={0}
                                    max={100}
                                    value={(getAlphaFromRgbaString(css.backgroundColor) ?? 1) * 100}
                                    onChange={e => {
                                        const newAlpha = Number(e.target.value) / 100;
                                        const { hex } = parseCssColor(css.backgroundColor);
                                        setCss({
                                            ...css,
                                            backgroundColor: hexToRgbaString(hex, newAlpha)
                                        });
                                    }}
                                />
                            </>
                        );
                        break;

                    case 'contorno':
                        content.push(
                            <>
                                <hr />
                                <p>Cor do Contorno do texto: {css.WebkitTextStrokeColor} </p>
                                <input
                                    className={styles.inputColor}
                                    type='color'
                                    onChange={e =>
                                        setCss({ ...css, WebkitTextStrokeColor: e.target.value })
                                    }
                                />

                                <p>Tamanho Contorno do Texto: {css.WebkitTextStrokeWidth} </p>
                                <input
                                    className={styles.range}
                                    type='range'
                                    min={0}
                                    max={10}
                                    step={0.1}
                                    value={parseFloat(css.WebkitTextStrokeWidth)}
                                    onChange={e => {
                                        setCss({
                                            ...css,
                                            WebkitTextStrokeWidth: e.target.value + 'px'
                                        });
                                    }}
                                />
                            </>
                        );

                        break;

                    case 'correta':
                        content.push(
                            <>
                                <p>Corretas: </p>
                                <input
                                    checked={correct}
                                    type='checkbox'
                                    onClick={e => {
                                        setCorrect(!correct);
                                        !correct && text == 'Coloque as opções incorretas aqui'
                                            ? setText('Coloque as opções corretas aqui')
                                            : correct && text == 'Coloque as opções corretas aqui'
                                            ? setText('Coloque as opções incorretas aqui')
                                            : console.log('');
                                    }}
                                />
                            </>
                        );

                        break;

                    case 'dropBoxes':
                        content.push(
                            <Select
                                styles={customStyles}
                                options={options}
                                value={dropAreas.map(e => e && { label: e.value, value: e.value })}
                                onChange={(e: any)=> {
                                    setDropAreas(e);
                                }}
                                isMulti
                                isSearchable
                                placeholder='Clique para selecionar...'
                            />
                        );
                        break;
                    case 'multiplo':
                        content.push(
                            <>
                                <p>Multiplas respostas: </p>
                                <input
                                    checked={multiplo}
                                    type='checkbox'
                                    onClick={e => {
                                        setMultiplo(!multiplo);
                                    }}
                                />
                            </>
                        );
                        break;
                    case 'url':
                        content.push(
                            <input
                                type='text'
                                value={url}
                                onChange={e => {
                                    setUrl(e.target.value);
                                }}
                                className={styles.input}
                            />
                        );
                        break;
                    case 'imagem':
                        // dentro do seu renderProps, no lugar do case 'imagem':
                        content.push(
                            <div key='imagem-upload'>
                                <hr />
                                <p>URL da imagem:</p>

                                {/* campo de texto para URL */}
                                <input
                                    type='text'
                                    value={imagem}
                                    onChange={e => setImagem(e.target.value)}
                                    className={styles.input}
                                    placeholder='Cole aqui uma URL...'
                                />

                                {/* botão que abre o seletor de arquivos */}
                                <label className={styles.uploadButton}>
                                    Upload de imagem…
                                    <input
                                        type='file'
                                        accept='image/*'
                                        onChange={handleImageUpload}
                                        style={{ display: 'none' }} // esconde o input real
                                    />
                                </label>
                            </div>
                        );
                        break;

                    case 'acessibilidadeImagem':
                        // dentro do seu renderProps, no lugar do case 'imagem':
                        content.push(
                            <div key='imagem-upload'>
                                <hr />
                                <p>URL da imagem Acessibilidade:</p>

                                {/* campo de texto para URL */}
                                <input
                                    type='text'
                                    value={css.backgroundImage}
                                    onChange={e => {
                                        setCss(prev => ({
                                            ...prev,
                                            backgroundImage: `url(${e.target.value})`
                                        }));
                                    }}
                                    className={styles.input}
                                    placeholder='Cole aqui uma URL...'
                                />

                                {/* botão que abre o seletor de arquivos */}
                                <label className={styles.uploadButton}>
                                    Upload de imagem…
                                    <input
                                        type='file'
                                        accept='image/*'
                                        onChange={async (e)=> { const image = await ImageToString(e); setCss(prev => ({...prev,backgroundImage: `url(${image})`}))}}
                                        style={{ display: 'none' }} // esconde o input real
                                    />
                                </label>
                            </div>
                        );
                }
            });
        }

        content.push(
            <button className={styles.delete} onClick={deleteSelected}>
                Deletar
            </button>
        );

        content.push(
            <label>
                Ordem: {css.zIndex}
                <input
                    type='range'
                    min={0}
                    max={100}
                    value={css.zIndex}
                    className={styles.range}
                    onChange={e => {
                        setCss(prev => ({ ...prev, zIndex: Number(e.target.value) }));
                    }}
                />
            </label>
        );

        return content;
    };

    function hexToRgbaString(hex: string, alpha: number) {
        const { r, g, b } = hexToRgb(hex);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    function hexToRgb(hex: string) {
        const h = hex.replace('#', '');
        const full =
            h.length === 3
                ? h
                      .split('')
                      .map(c => c + c)
                      .join('')
                : h;
        const r = parseInt(full.slice(0, 2), 16);
        const g = parseInt(full.slice(2, 4), 16);
        const b = parseInt(full.slice(4, 6), 16);
        return { r, g, b };
    }
    function rgbToHex(r: number, g: number, b: number) {
        const toHex = (n: number) => n.toString(16).padStart(2, '0');
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    }
    function parseCssColor(input: string) {
        // tenta rgba/rgba, depois hex
        const rgbaMatch = input.match(
            /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*([0-9.]+))?\s*\)/i
        );
        if (rgbaMatch) {
            const r = Number(rgbaMatch[1]);
            const g = Number(rgbaMatch[2]);
            const b = Number(rgbaMatch[3]);
            const a = rgbaMatch[4] !== undefined ? Number(rgbaMatch[4]) : 1;
            return {
                hex: rgbToHex(r, g, b),
                alpha: Math.max(0, Math.min(1, a))
            };
        }
        // se já é hex (#rrggbb ou #rgb)
        if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(input)) {
            return { hex: input, alpha: 1 };
        }
        // fallback
        return { hex: '#000000', alpha: 1 };
    }
    function parseAlphaPart(part: string): number | null {
        part = part.trim();
        if (part.endsWith('%')) {
            const n = parseFloat(part);
            if (Number.isFinite(n)) return Math.max(0, Math.min(1, n / 100));
            return null;
        }
        const n = parseFloat(part);
        if (Number.isFinite(n)) return Math.max(0, Math.min(1, n));
        return null;
    }

    /**
     * Retorna o alpha (0..1) de uma string 'rgba(...)' ou 'rgb(...)'.
     * - suporta: "rgba(255,0,0,0.5)", "rgb(255 0 0 / 50%)", "rgb(255,0,0)" -> 1
     * - retorna null se a string não for reconhecida
     */
    function getAlphaFromRgbaString(input: string): number | null {
        if (!input || typeof input !== 'string') return null;
        const s = input.trim();
        const m = s.match(/^rgba?\(\s*([^)]+)\)$/i);
        if (!m) return null;
        const inside = m[1].trim();

        // se usar o formato com slash: "rgb(...) / alpha" ou "rgba(...) r g b / a"
        if (inside.includes('/')) {
            const parts = inside.split('/');
            if (parts.length < 2) return null;
            return parseAlphaPart(parts.slice(-1)[0]);
        }

        // caso com vírgulas: "r,g,b,a"
        const commaParts = inside.split(',').map(p => p.trim());
        if (commaParts.length === 4) {
            return parseAlphaPart(commaParts[3]);
        }

        // sem alpha explícito: "rgb(255,0,0)" ou "rgb(255 0 0)"
        return 1;
    }

    const customStyles = {
        /* ... seus estilos anteriores ... */
        valueContainer: provided => ({
            ...provided,
            flexWrap: 'wrap',
            whiteSpace: 'normal', // permite quebra de linha
            overflow: 'visible' // mostra todo o conteúdo
        }),
        multiValueLabel: provided => ({
            ...provided,
            fontSize: '1vw',
            whiteSpace: 'normal', // aceita múltiplas linhas
            overflow: 'visible',
            textOverflow: 'clip',
            color: 'black',
            lineHeight: '1.2em'
        }),
        multiValue: provided => ({
            ...provided,
            backgroundColor: '#e0e0e0',
            padding: '2px 6px',
            height: 'auto',
            display: 'inline-flex',
            alignItems: 'flex-start',
            flexWrap: 'wrap'
        }),
        singleValue: provided => ({
            ...provided,
            whiteSpace: 'normal',
            overflow: 'visible'
        }),

        option: (provided: any, state: any) => ({
            ...provided,
            fontSize: '1vw',
            whiteSpace: 'normal', // permite quebra de texto
            wordBreak: 'break-word', // quebra livre, se necessário
            color: 'black'
        })
    };

    return (
        <div className={styles.jsonCode}>
            <h3 className={styles.propTitulo}>{selected.name}</h3>
            <div className={styles.frame}>{renderProps(selected.type || 'alternativa')}</div>
            <br />
        </div>
    );
}
